import { detectPlatform } from './detect';
import type { PlatformAdapter } from './types';
import { MOCK_ADAPTER } from './mock';

let cached: PlatformAdapter | null = null;

export async function getPlatform(): Promise<PlatformAdapter> {
  if (cached) return cached;
  const p = detectPlatform();
  if (p === 'telegram') cached = (await import('./tg')).TelegramAdapter;
  else if (p === 'vk')  cached = (await import('./vk')).createVkAdapter();
  else if (p === 'max') cached = (await import('./max')).createMaxAdapter();
  else                  cached = MOCK_ADAPTER;
  return cached!;
}

export function _resetPlatformCache(): void {
  cached = null;
}
